export default __webpack_public_path__ + "static/media/staff_inactive.66326795.svg";